"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("@emotion/react");

var _flat = _interopRequireDefault(require("flat"));

/* This is a duplicate of Emotion themes as css variables
 * In order to allow access to the theme from LESS
 */
var convertThemeToCssVariables = function convertThemeToCssVariables(theme) {
  var flatTheme = (0, _flat["default"])(theme, {
    delimiter: '-'
  });
  var rootVars = Object.entries(flatTheme).map(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return "--".concat(key, ": ").concat(value, ";");
  }).join('');
  return /*#__PURE__*/(0, _react.css)(":root{", rootVars, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:convertThemeToCssVariables;"));
};

var _default = function _default(theme) {
  return convertThemeToCssVariables(theme);
};

exports["default"] = _default;
//# sourceMappingURL=cssVariables.js.map